module.exports = __webpack_public_path__ + "media/notisound.feb29173.mp3";